/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Mon May 30 2022
*  File : LoginMode.ts
*******************************************/

export enum LoginMode {
    AUTO = "AUTO",
    SESSION = "SESSION",
    MANUAL = "MANUAL"
}